import React, { useState } from 'react'
import { CircleFlag } from 'react-circle-flags'

import { MARKET_CODES, MARKET_CONFIGS, MarketCode, useMarket } from '@/shared/market'
import { pxToRem } from '@/shared/styles/themes'
import { MenuItem, Popover, styled, Typography } from '@mui/material'

export const MarketSelector: React.FC = () => {
  const { market, setMarket } = useMarket()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = (code: MarketCode) => {
    setMarket(code)
    handleClose()
  }

  return (
    <>
      <StyledTrigger onClick={handleClick}>
        <CircleFlag countryCode={market.code.toLowerCase()} height={24} />
        <StyledTypography variant="body2" color="inherit">
          {market.label}
        </StyledTypography>
      </StyledTrigger>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        {MARKET_CODES.map((code) => {
          const config = MARKET_CONFIGS[code]

          return (
            <StyledMenuItem
              key={code}
              selected={code === market.code}
              onClick={() => handleSelect(code)}
            >
              <CircleFlag countryCode={code.toLowerCase()} height={20} />
              <Typography variant="body2">{config.label}</Typography>
            </StyledMenuItem>
          )
        })}
      </Popover>
    </>
  )
}

const StyledTypography = styled(Typography)`
  color: ${props => props.theme.palette.custom.footer.text};
`

const StyledTrigger = styled('button')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: pxToRem(8),
  padding: `${pxToRem(8)} ${pxToRem(8)}`,
  background: 'transparent',
  border: 'none',
  borderRadius: pxToRem(25),
  cursor: 'pointer',
  color: 'inherit',
  fontSize: pxToRem(12),

  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
}))

const StyledMenuItem = styled(MenuItem)({
  display: 'flex',
  alignItems: 'center',
  gap: pxToRem(10),
  minWidth: pxToRem(180),
})
